export default {
  'aws.title': 'Pedido de Amazon',
  'aws.business': 'ID de Producto/Pedido',
  'aws.orderStatus': 'Estado del pedido',
  'aws.aswStatus': 'Estado de suscripción',
  'aws.orderInfo': 'Información del pedido',
  'aws.expireTime': 'Fecha de expiración',
  'aws.createTime': 'Fecha de creación',
  'aws.pending': 'Pendiente de activación',
  'aws.unbind': 'Pendiente de vinculación',
  'aws.bound': 'Vinculado',
  'aws.cancelled': 'Cancelado',
  'aws.activeText': 'Activación tras {time}',
  'aws.operate': 'Acciones',
  'aws.bindTips': 'Pedido pendiente de activación, operación no disponible',
  'aws.bind': 'Vincular',
  'aws.engageLabOrder': 'Pedido de EngageLab',
  'aws.whatsapp.recharge': 'Recargar',
  'aws.whatsapp.recharge.price': 'Importe de recarga',
  'aws.apppush.dataCenter': 'Centro de datos',
  'aws.apppush.dau': 'DAU (Usuarios Diarios Activos)',
  'aws.apppush.vip': 'Duración de VIP',
  'aws.email.tips': 'Paquete de Email/Tráfico/IP Independiente',
  'aws.email': 'Cantidad de emails',
  'aws.email.ip': 'Cantidad de IPs independientes',
  'aws.email.flow': 'Regarcar tráfico',
  'aws.choose.service': 'Seleccionar servicio EngageLab',
  'aws.choose.organization': 'Organización',
  'aws.choose.nodata': 'Sin aplicaciones disponibles',
  'aws.choose.whatsapp': 'Cuenta empresarial',
  'aws.choose.app': 'Aplicación',
  'aws.order.title': 'Vincular pedido de Amazon',
  'aws.order.information': 'Información del pedido Amazon',
  'aws.order.id': 'ID del pedido',
  'aws.order.product': 'Tipo de producto',
  'aws.bind.success': 'Vinculación exitosa',
  'aws.bind.modal.create': 'Crear {appName}',
  'aws.month': '{number} meses',
  'aws.allBusiness': 'Todos los productos',
  'aws.order.status': 'Estado del pedido',
  'aws.aswStatus.refunded': 'Reembolsado',
  'aws.aswStatus.expired': 'Expirado',
  'aws.aswStatus.subscribed': 'Suscrito',
  'aws.aswStatus.upgraded': 'Actualizado',
  'aws.aswStatus.renewed': 'Renovado automático',
  'aws.aswStatus.cancelled': 'Cancelado',
  'aws.aswStatus.refunded.tips':
    'Este pedido ha sido reembolsado en Amazon, contacte al departamento comercial para detalles',
  'aws.aswStatus.upgraded.tips':
    'Este pedido ha sido actualizado en Amazon. Para aplicar la actualización en EngageLab, contacte a ventas. El paquete actualizado es el siguiente',
  'aws.bindTips.cancelled': 'Pedido cancelado en Amazon',
  'aws.bindTips.unbind': 'El pedido está {status} en Amazon, contacte al departamento comercial',
  'aws.bindTips.unbind.status.refunded': 'Reembolsado',
  'aws.bindTips.unbind.status.expired': 'Expirado',
  'aws.bindTips.unbind.status.upgraded': 'Actualizado',
  'aws.bindTips.unbind.status': 'Reembolsado/Expirado/Actualizado',
  'aws.nodata': 'Sin datos disponibles',
  'aws.jumpEmail':
    'Acceda a <a href="https://www.engagelab.com/console/email/#/email/{orgid}/sendSetting/domain" target="_blank">Email</a> para configurar el dominio',
};
